/*
 * @Author: jay
 * @Date: 2021-07-20 17:30:00
 * @LastEditTime: 2021-07-20 17:35:04
 * @Description: cookie工具
 */
import cookie from 'js-cookie'

export const GetCookie=(key:string)=>{
    return cookie.get(key)
}

export const SetCookie=(key:string,data:any,second:number)=>{
    let expires:any = new Date((new Date() as any) * 1 + second*1000);
    return cookie.set(key,data,{expires})
}

export const removeCookie=(key:string)=>{
    return cookie.remove(key)
}